export const VerifyLinkSent = ({ email }: { email: string }) => {
  return (
    <span>
      Please check your inbox at <span className="font-semibold">{email}</span>{' '}
      for the verification link.
    </span>
  );
};

export const ResetLinkSent = ({ email }: { email: string }) => {
  return (
    <span>
      Please check your inbox at <span className="font-semibold">{email}</span>{' '}
      for a password reset link.
    </span>
  );
};
